import React from 'react';
import {
  DELIVERY_HUB,
  DELIVERY_HOME,
  HUB_TEMPERATURE_LINE,
  HOME_TEMPERATURE_LINE,
} from '../../constants/shippingTemperatures';

/**
 * The ONE temperature-policy sentence set, shared by the address step, the
 * payment step and the order confirmation (fix batch 42).
 *
 *   method="hub"  → the hub window only, never the word "Residential"
 *   method="home" → the home-delivery window only
 *   anything else → BOTH, on two short lines (the step where the customer
 *                   is still choosing, or a method we cannot read)
 *
 * The host keeps its own frame (card, alert) and its own links — the
 * shipping-policy link and the support email are the host's, not this
 * component's — so each page's chrome is unchanged.
 */
export default function ShippingTemperatureNotice({ method, lineClassName, label = 'Temperature Policy:' }) {
  const lines = method === DELIVERY_HUB
    ? [HUB_TEMPERATURE_LINE, 'If temperatures fall outside that range, we may need to reschedule.']
    : method === DELIVERY_HOME
      ? [HOME_TEMPERATURE_LINE, 'If unsafe temperatures develop, we may need to reschedule or switch you to FedEx hub pickup.']
      : [HUB_TEMPERATURE_LINE, HOME_TEMPERATURE_LINE];
  return (
    <div className="ff-temp-notice" data-temp-notice={method === DELIVERY_HUB || method === DELIVERY_HOME ? method : 'both'}>
      <p className={lineClassName}>
        {label && <><strong>{label}</strong>{' '}</>}
        {lines[0]}
      </p>
      <p className={lineClassName}>{lines[1]}</p>
    </div>
  );
}
